import { useCallback, useEffect, useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { ErrorBoundary } from "react-error-boundary";
import { FallBack, NotFound, Spacer } from "../components";
import { Navbar } from "../components/Navbar";
import { AppLoader } from "../components/Loader";
import { awaitFirestoreData, FirestoreContext } from "../context/Context";
import { FirestoreData } from "../interfaces";
import { useSearch } from "../context/SearchContext";
import favicon from "../assets/logo.png";
import SearchResults from "../pages/Search/SearchResults";
import {
  About,
  Article,
  Articles,
  Books,
  Gem,
  Lyrical,
  Themes,
} from "../pages";

const Routing = () => {
  const location = useLocation();
  const { searchQuery, setSearchQuery } = useSearch();
  const [isDataLoaded, setIsDataloaded] = useState(false);
  const [firestoreData, setFirestoreData] = useState<FirestoreData>({
    articles: [],
    lyricals: [],
  });

  useEffect(() => {
    // Clear search results when user navigates to a new page via navbar
    setSearchQuery("");
  }, [location, setSearchQuery]);

  const getData = useCallback(async () => {
    const data = await awaitFirestoreData();
    setFirestoreData(data);
    setIsDataloaded(true);
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  const showSearch = searchQuery.trim().length > 0;

  return (
    <FirestoreContext.Provider value={firestoreData}>
      <HelmetProvider>
        <Helmet>
          <link rel="icon" href={favicon} />
          <title>Truth Miner</title>
        </Helmet>
        <Navbar />
        <Spacer />
        {!isDataLoaded ? (
          <AppLoader />
        ) : (
          <ErrorBoundary FallbackComponent={FallBack} resetKeys={[location]}>
            {showSearch ? (
              <SearchResults />
            ) : (
              <Routes>
                <Route path="/" element={<Navigate to="/nuggets" />} />
                <Route path="/nuggets" element={<Articles />} />
                <Route path="/nuggets/:id" element={<Article />} />
                <Route path="/gold" element={<Themes />} />
                <Route path="/gems" element={<Lyrical />} />
                <Route path="/gems/:id" element={<Gem />} />
                <Route path="/books" element={<Books />} />
                <Route path="/prospector" element={<About />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            )}
          </ErrorBoundary>
        )}
      </HelmetProvider>
    </FirestoreContext.Provider>
  );
};

export default Routing;
